import type { WalletProviderKey } from '@ulp/consumer-core';

// isPhase1 / hasCapability native uygulamayla ORTAK (consumer-core/phase1) — tek kural.
export { hasCapability, isPhase1 } from '@ulp/consumer-core';

/** Cihaz: iOS → Apple Wallet, Android → Google Wallet, masaüstü → ikisi. */
export function preferredWallets(ua = typeof navigator !== 'undefined' ? navigator.userAgent : ''): WalletProviderKey[] {
  if (/iPhone|iPad|iPod/i.test(ua) || (/Macintosh/i.test(ua) && typeof navigator !== 'undefined' && navigator.maxTouchPoints > 1)) return ['APPLE'];
  if (/Android/i.test(ua)) return ['GOOGLE'];
  return ['APPLE', 'GOOGLE'];
}
